export default __webpack_public_path__ + "static/media/banner-doubt.a3362cb9.png";